import { z } from "zod";

export const baseTaxSchema = z.object({
  taxDesignation: z
    .string({
      required_error: "Tax designation is required",
    })
    .min(1, "Tax designation cannot be empty"),
  taxRate: z.coerce
    .number({
      required_error: "Tax rate is required",
    })
    .min(0, "Tax rate cannot be negative")
    .max(100, "Tax rate cannot exceed 100%"),
  isDefault: z.boolean().optional().nullable(),
  cumulativeTaxIds: z.array(z.string().uuid()).optional(),
});
export const createTaxSchema = baseTaxSchema;

export const updateTaxSchema = createTaxSchema.partial().extend({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const getTaxSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const deleteTaxSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const listTaxesSchema = z.object({
  organizationId: z.string().optional().nullable(),
  isDefault: z.boolean().optional().nullable(),
  limit: z.number().positive().optional().nullable().default(50),
  offset: z.number().nonnegative().optional().nullable().default(0),
});

export type ZodCreateTaxSchema = z.infer<typeof createTaxSchema>;
export type ZodUpdateTaxSchema = z.infer<typeof updateTaxSchema>;
export type ZodGetTaxSchema = z.infer<typeof getTaxSchema>;
export type ZodDeleteTaxSchema = z.infer<typeof deleteTaxSchema>;
export type ZodListTaxesSchema = z.infer<typeof listTaxesSchema>;

export const taxSchema = baseTaxSchema.extend({
  id: z.string(),
  organizationId: z.string(),
  createdAt: z.date(),
  cumulativeTaxes: z.array(z.lazy((): z.ZodTypeAny => taxSchema)).optional(),
  updatedAt: z.date(),
});

export const documentTaxSchema = baseTaxSchema.extend({
  id: z.string(),
  cumulativeTaxes: z.array(z.lazy((): z.ZodTypeAny => documentTaxSchema)).optional(),
});

export type TaxSchema = z.infer<typeof taxSchema>;
export type DocumentTaxSchema = z.infer<typeof documentTaxSchema>;

export const createTaxSchemaDefaultValues: ZodCreateTaxSchema = {
  taxDesignation: "",
  taxRate: 0,
  isDefault: false,
  cumulativeTaxIds: [],
};
